import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import WhatIs from './components/WhatIs';
import Features from './components/Features';
import CTAConversion from './components/CTAConversion';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.cam';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  description: 'The ultimate Superbuy Spreadsheet resource center. Learn how to use Superbuy Spreadsheet templates, organize products, compare tools, and improve your shopping workflow.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
  description: 'The ultimate Superbuy Spreadsheet resource providing templates, guides, comparisons, and expert tips for smarter shopping decisions.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <main>
        <Navbar />
        <Hero />
        <CategoryGrid />
        <WhatIs />
        <Features />
        <CTAConversion />
        <Testimonials />
        <Footer />
      </main>
    </>
  );
}